/**
 * @module Router
 * @category Router
 */

import Vue from 'vue'
import VueRouter from 'vue-router'
import { configureMiddlewares } from './router-middlewares'
import configureRouterStore from './router-store'
import routes from './routes'
import { getQueryStringValue } from '@/utils/querystring'
import envService from '@/services/env-service.js'

Vue.use(VueRouter)

const router = new VueRouter({
  //TODO: The history mode is preferred and should be set once the server support it.
  //mode: "history",
  routes,
})

configureRouterStore(router)

//Skip middlewares if ?mockapp=1 on dev envs
if (!(getQueryStringValue('mockapp') === '1' && !envService.isProduction())) {
  configureMiddlewares(router)
}

export default router
